import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classname from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getChangeTypeCellStyles } from '../styles';
import { CellItemHeight } from '../constants';

function ChangeTypeCellItem({
  value, className, hasBorderBottomLine, itemHeight,
}) {
  const classes = useDefaultStyles(getChangeTypeCellStyles);
  return (
    <div className={classname(
      'change-type-cell-item',
      className,
      classes.ChangeTypeItem,
      classes[`ChangeTypeItem-${itemHeight}`],
      hasBorderBottomLine && classes.BorderBottomLine
    )}
    >
      {value}
    </div>
  );
}

ChangeTypeCellItem.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  hasBorderBottomLine: PropTypes.bool,
  itemHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
ChangeTypeCellItem.defaultProps = {
  value: null,
  className: null,
  hasBorderBottomLine: false,
  itemHeight: null,
};

// At least one of the three values is not null: spendAmount, adjustmentAmount, budgetChangeAmount
export function ChangeTypeCell({
  spend,
  adjustment,
  budgetChange,
  withBudgetChangeDescription,
}) {
  const classes = useDefaultStyles(getChangeTypeCellStyles);
  const hasSpendUnderLine = useMemo(() => !!adjustment || !!budgetChange, [adjustment, budgetChange]);
  const hasAdjustmentUnderLine = useMemo(() => !!budgetChange, [budgetChange]);

  return (
    <div className={classname('change-type-cell', classes.ChangeTypeCell)}>
      {!!spend && <ChangeTypeCellItem
        value={spend}
        className="change-type-spend"
        hasBorderBottomLine={hasSpendUnderLine}
        itemHeight={CellItemHeight.Small}
      />}
      {!!adjustment && <ChangeTypeCellItem
        value={adjustment}
        className="change-type-adjustment"
        hasBorderBottomLine={hasAdjustmentUnderLine}
        itemHeight={CellItemHeight.Small}
      />}
      {!!budgetChange && <ChangeTypeCellItem
        value={budgetChange}
        className="change-type-budget-change"
        itemHeight={withBudgetChangeDescription ? CellItemHeight.Large : CellItemHeight.Small}
      />}
    </div>
  );
}

ChangeTypeCell.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  spend: PropTypes.string,
  adjustment: PropTypes.string,
  budgetChange: PropTypes.string,
  withBudgetChangeDescription: PropTypes.bool,
};

ChangeTypeCell.defaultProps = {
  spend: null,
  adjustment: null,
  budgetChange: null,
  withBudgetChangeDescription: false,
};
